function componentTimeArticle() {
  if ($('.js-time').length) {
    var article = $('.section-blog-detail article')
    var articleText = article.text()
    var time = $('.js-time')
    var timeValue = $('.js-time-value')

    const wordsArray = articleText.split(' ')
    const wordCount = wordsArray.length

    const wordsPerMinute = 200
    const readingTime = Math.ceil(wordCount / wordsPerMinute)

    timeValue.text(readingTime)

    time.addClass('is-active')
  }
}
